var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalKemasanEdit",
    attrs: {
      "id": "modal-kemasan-edit",
      "title": "Edit Kemasan",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": _vm.model('JML_KMS'),
      "type": "number",
      "name": "Jumlah Kemasan"
    },
    on: {
      "input": function($event) {
        _vm.updateKemasan('JML_KMS', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Kemasan')))]), _vm._v(" "), _c('small', [_vm._v("Isikan Jumlah Total Kemasan")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "value": _vm.model('JNS_KMS'),
      "list": _vm.JenisKemasan,
      "option-value": "JNS_KMS",
      "custom-text": function (item) { return ((item.JNS_KMS) + " - " + (item.UR_KMS)); }
    },
    on: {
      "input": function($event) {
        _vm.updateKemasan('JNS_KMS', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kemasan')) + " ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.saveUpdateKemasan()
      }
    }
  }, [_vm._v("Simpan")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f095b1d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/modal/ModalKemasanEdit.vue
// module id = 365
// module chunks = 0